import type { StyleSelection } from "src/pages/ad-studio/components/ad-studio-style-select";

export const AUTO_LABEL = "Auto";
export const NO_STYLE_LABEL = "No style";

/** The picker label for a style choice; a style missing from the options reads as Auto. */
export function styleSelectionLabel(
  value: StyleSelection,
  styles: ReadonlyArray<{ id: string; name: string }> | undefined,
): string {
  if (value.kind === "none") {
    return NO_STYLE_LABEL;
  }
  if (value.kind === "auto") {
    return AUTO_LABEL;
  }
  return styles?.find((style) => style.id === value.id)?.name ?? AUTO_LABEL;
}
